import React from 'react';
import { StyledTryAgainButton } from './TryAgainButton.styles';
import { useNavigate } from 'react-router-dom';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { Tenant, TENANT_NAME } from '../../config/tenants';

export const TryAgainButton: React.FC = () => {
  const { t } = useTypedTranslate();
  const navigate = useNavigate();

  const handleTryAgain = (): void => {
    navigate('/');
  };

  const typeStyle = TENANT_NAME === Tenant.INTER_RISK ? 'secondary' : 'outlined';

  return (
    <StyledTryAgainButton typeStyle={typeStyle} onClick={handleTryAgain}>
      {t('MAKE_PHOTO_AGAIN')}
    </StyledTryAgainButton>
  );
};
